import { Button } from '@/ui';
import {
  FiFile,
  FiFolder,
  FiFolderPlus,
  FiTrash2,
  FiUpload,
} from 'react-icons/fi';
import {
  ToolbarContainer,
  ToolbarLeft,
  ToolbarRight,
  ViewToggleContainer,
  ViewToggleButton,
  ActionButtonsContainer,
} from './Toolbar.styles';
import { DataRoomFile } from '@/types/documents/documents.types';

interface ToolbarProps {
  activeCollectionFilter: string | null;
  setActiveCollectionFilter: (filter: string | null) => void;
  documentsWithCollection: DataRoomFile[];
  setShowCreateSmartCollectionModal: (show: boolean) => void;
  setShowCreateCollectionModal: (show: boolean) => void;
  setShowUploadModal: (show: boolean) => void;
  setUploadMode: (mode: 'files' | 'url') => void;
  viewMode: 'file' | 'folder';
  setViewMode: (mode: 'file' | 'folder') => void;
  multiSelectEnabled?: boolean;
  selectedCount?: number;
  onToggleMultiSelect?: () => void;
  onDeleteSelected?: () => void;
  isCompact?: boolean;
}

export const Toolbar = ({
  setShowCreateCollectionModal,
  setShowUploadModal,
  setUploadMode,
  viewMode,
  setViewMode,
  multiSelectEnabled = false,
  selectedCount = 0,
  onToggleMultiSelect,
  onDeleteSelected,
  isCompact = false,
}: ToolbarProps) => {
  const buttonSize = isCompact ? 'sm' : 'md';

  return (
    <ToolbarContainer $isCompact={isCompact}>
      <ToolbarLeft>
        <ViewToggleContainer $isCompact={isCompact}>
          <ViewToggleButton
            active={viewMode === 'file'}
            $isCompact={isCompact}
            onClick={() => setViewMode('file')}
          >
            {isCompact ? <FiFile /> : '📄'} File View
          </ViewToggleButton>
          <ViewToggleButton
            active={viewMode === 'folder'}
            $isCompact={isCompact}
            onClick={() => setViewMode('folder')}
          >
            {isCompact ? <FiFolder /> : '📁'} Folder View
          </ViewToggleButton>
        </ViewToggleContainer>
      </ToolbarLeft>
      <ToolbarRight>
        <ActionButtonsContainer $isCompact={isCompact}>
          {/* Smart Collections temporarily disabled - not properly set up */}
          <Button
            variant="primary"
            size={buttonSize}
            onClick={() => setShowCreateCollectionModal(true)}
            style={{ fontWeight: 600 }}
            leftIcon={isCompact ? <FiFolderPlus /> : undefined}
          >
            {isCompact ? 'Create Collection' : '📁 Create Collection'}
          </Button>
          <Button
            variant="primary"
            size={buttonSize}
            onClick={() => {
              setUploadMode('files');
              setShowUploadModal(true);
            }}
            style={{ fontWeight: 600 }}
            leftIcon={isCompact ? <FiUpload /> : undefined}
          >
            {isCompact ? 'Upload Documents' : '📤 Upload Documents'}
          </Button>
          {onToggleMultiSelect && (
            <Button
              variant={multiSelectEnabled ? 'outline' : 'block'}
              size={buttonSize}
              onClick={onToggleMultiSelect}
              style={{ fontWeight: 600 }}
            >
              {multiSelectEnabled ? 'Cancel Select' : 'Select Documents'}
            </Button>
          )}
          {multiSelectEnabled && onDeleteSelected && (
            <Button
              variant="outline"
              size={buttonSize}
              onClick={onDeleteSelected}
              disabled={selectedCount === 0}
              style={{ fontWeight: 600 }}
              leftIcon={isCompact ? <FiTrash2 /> : undefined}
            >
              {isCompact ? '' : '🗑️ '}Delete Selected
              {selectedCount > 0 ? ` (${selectedCount})` : ''}
            </Button>
          )}
        </ActionButtonsContainer>
      </ToolbarRight>
    </ToolbarContainer>
  );
};
